<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     根组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div id="app">
    <router-view />
    <el-tooltip popper-class="tagmanager" placement="top" ref="tooltip" :content="tooltipContent"></el-tooltip>
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      // 为el-tooltip设置content值
      tooltipContent: "",
      url: null,
    };
  },
  created() {

  },
};
</script>
